export const SHADING_TOF_VALUE_COUNT = 13;

export const monthHasPositiveDni = (month) =>
  Array.isArray(month) && month.some((row) => Array.isArray(row) && Number.isFinite(row[3]) && row[3] > 0);

export const getShadingRequiredClientDataValidationError = (data, segmentCount) => {
  if (!Array.isArray(data?.irradiance_data) || data.irradiance_data.length !== 12) {
    return 'irradiance_data does not include 12 months';
  }

  for (let monthIndex = 0; monthIndex < 12; monthIndex += 1) {
    if (!monthHasPositiveDni(data.irradiance_data[monthIndex])) {
      return `irradiance_data[${monthIndex}] has no positive DNI`;
    }
  }

  if (!Array.isArray(data?.tof_data)) {
    return 'missing tof_data';
  }

  if (data.tof_data.length !== segmentCount) {
    return `tof_data segment count ${data.tof_data.length} does not match current segment count ${segmentCount}`;
  }

  for (let segmentIndex = 0; segmentIndex < segmentCount; segmentIndex += 1) {
    const row = data.tof_data[segmentIndex];

    if (!Array.isArray(row) || row.length < SHADING_TOF_VALUE_COUNT) {
      return `tof_data[${segmentIndex}] does not include 12 months plus annual value`;
    }
    if (row.slice(0, SHADING_TOF_VALUE_COUNT).some((value) => !Number.isFinite(value))) {
      return `tof_data[${segmentIndex}] contains invalid values`;
    }
  }

  return null;
};
